module.exports = __webpack_public_path__ + "static/media/ic_etiqueta_magenta.14e33dc6.webp";


//////////////////
// WEBPACK FOOTER
// ./assets/img/ic_etiqueta_magenta.webp
// module id = 196
// module chunks = 1